import { handleActions } from 'redux-actions';
import moment from 'moment';
import qs from 'qs';
import _get from 'lodash/get';

import createCalendar, { getDateRangeWithTimeZoneFromCalendar } from '../../shared/calendar';
import createFilters, { getFiltersObject } from '../../shared/fixed-filters';
import http from '../../shared/http';

import endpoints from '../../../config/endpoints';

export const namespace = 'marketingFunnelAffiliateStat';

const calendar = createCalendar({
	namespace,
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().startOf('year').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace,
	stateNodeName: 'filters',
	listOfFilters: [{
		name: 'affiliates',
		title: 'Affiliates',
		placeholder: 'Add affiliates',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.AFFILIATES
		}
	}]
});

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
const APPLY = `${namespace}/apply`;
const CLEAR = `${namespace}/clear`;

// initial state
const initialState = {
	isLoading: true,
	isError: false,
	data: null,
	table: {
		columns: {
			domain: {
				index: 'ID',
				title: 'id'
			},
			referer: {
				index: 'referer',
				title: 'Referer'
			},
			tags: {
				index: 'tags',
				title: 'Tags'
			},
			lead_source_names: {
				index: 'lead_source_names',
				title: 'Lead Sources'
			},
			country_name: {
				index: 'country_name',
				title: 'Country'
			},
			registered_at: {
				index: 'registered_at',
				title: 'Registered at'
			},
			start_traffic_date: {
				index: 'start_traffic_date',
				title: 'Traffic starts at'
			},
			total_leads: {
				index: 'total_leads',
				title: 'Total/Appr Leads'
			}
		},
		sortByColumn: {
			index: 'created_at',
			title: 'Created at',
			direction: 'desc'
		}
	},
	filters: filters.initialState,
	calendar: calendar.initialState
};

// actions
export const actions = Object.assign({
	fetchData: () => (dispatch, getState) => {
		const tempQueryString = localStorage.getItem('tempQueryString') || '';
		const tempQueryStringObject = qs.parse(tempQueryString.replace('?', ''));

		if (_get(tempQueryStringObject, 'filters', null)) {
			dispatch(filters.actions.initializeFiltersFromQueryObject(
				tempQueryStringObject.filters
			));
			localStorage.removeItem('tempQueryString');
		}
		request(getRequestQuery(getState))(dispatch);
	},
	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),
	apply: () => (dispatch, getState) => {
		dispatch({ type: APPLY });
		dispatch(actions.fetchData());
	},
	clear: () => (dispatch, getState) => {
		dispatch({ type: CLEAR });
		dispatch(actions.fetchData());
	}
},
filters.actions,
calendar.actions
);

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				isLoading: false,
				isError: false
			};
		},
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		}),
		[APPLY]: (state, action) => ({
			...state,
			data: null,
			isLoading: true
		}),
		[CLEAR]: (state, action) => initialState
	},
	filters.reducers,
	calendar.reducers
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getTable: state => {
		return {
			columns: state[namespace].table.columns,
			rows: state[namespace].data || []
		};
	},
	getFilters: state => filters.selectors.getFilters(
		state => state[namespace].filters,
		state => state
	)(state),
	getCalendar: state => calendar.selectors.getCalendar(
		state => state[namespace].calendar,
		state => state
	)(state)
};

function getRequestQuery(getState) {
	const state = getState()[namespace];

	const range = getDateRangeWithTimeZoneFromCalendar(state.calendar);
	const filters = getFiltersObject(state.filters, false);
	const affiliates = filters.affiliates;
	console.log('\nfilters_affiliates', filters, '\n');
	console.log('\nstate.filters', state.filters, '\n');
	delete filters.affiliates;

	return {
		dates: [range.start, range.end],
		filters,
		affiliates: affiliates
	};
}

function request(query) {
	return http({
		url: 'v2/marketing-funnel/affiliate-stat',
		method: 'get',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		query
	});
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/affiliate-stat/index.js